import Reconciliation from '../features/reconciliation';

export const ReconciliationPage = () => <Reconciliation />;
